import { render, staticRenderFns } from "./project_list_add.vue?vue&type=template&id=677cd4ce&scoped=true&"
import script from "./project_list_add.vue?vue&type=script&lang=js&"
export * from "./project_list_add.vue?vue&type=script&lang=js&"
import style0 from "./project_list_add.vue?vue&type=style&index=0&id=677cd4ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677cd4ce",
  null
  
)

export default component.exports